export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const formatCurrency = (amount, locale = "en-US", currency = "USD") => {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  });
  return formatter.format(amount);
};

export const formatDate = (isoDateString) => {
  const date = new Date(isoDateString);

  // Check if the date is valid
  if (isNaN(date)) {
    return "Invalid Date";
  }

  
  // return   date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();

  // Format the date to "MMMM d, yyyy"
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });};

export const checkNaN = (num) => {
  return isNaN(num) ? 0 : num;
};

export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  // Show 5 years in the past and 5 years in the future
  for (let year = currentYear - 3; year <= currentYear + 3; year++) {
    years.push(year);
  }
  return years;
};

export const getAuthToken = () => {
  let userState = localStorage.getItem("authState");
  userState = JSON.parse(userState);
  return userState?.userDetails?.token;
};
